import "regenerator-runtime/runtime";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { fork, all } from 'redux-saga/effects';
import { watchRemoveChildWindowFromHistory } from './child-windows/child-windows-saga';
import watchFieldChange from './fields/sagas/change-field';
import watchFieldReset from './fields/sagas/reset-field';
import watchFieldsChange from './fields/sagas/change-fields';
import watchExecuteCallbacks from './fields/sagas/execute-callbacks';
import watchValidateFields from './fields/sagas/validate-fields';
import watchUpdateDependents from './form-dependencies/sagas/update-dependencies';
import watchFormValidate from './forms/sagas/validate-form';
import watchFormSubmit from './forms/sagas/submit-form';
import watchCancelInterdiction from './interdiction/sagas/cancel-interdiction';
import watchResumeAfterInterdiction from './interdiction/sagas/resume-after-interdiction';
import watchRequestNewCode from './interdiction/sagas/request-new-code';
import watchGetOowView from './interdiction/sagas/get-oow-view';
import watchStartInterdiction from './interdiction/sagas/start-interdiction';
import { watchWorkingStart, watchWorkingEnd } from './working/working-saga';
import watchCmsRequest from './cms/cms-saga';
import watchWFCmsRequest from './wf-cms/sagas/cms-saga';
import { watchWFCmsRequestMojoComponents } from './wf-cms/sagas/cms-mojo-saga';
import { watchInitializeTrusteer } from './fraud/sagas/trusteer-initialize';
import { watchSetTrusteerContext } from './fraud/sagas/trusteer-set-context';
import { watchNudataDetectFraud } from './fraud/sagas/nudata-detect-fraud';
var digitalCoreSagas = /*#__PURE__*/regeneratorRuntime.mark(function digitalCoreSagas() {
  return regeneratorRuntime.wrap(function digitalCoreSagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([fork(watchRemoveChildWindowFromHistory), fork(watchFieldChange), fork(watchFieldReset), fork(watchFieldsChange), fork(watchExecuteCallbacks), fork(watchUpdateDependents), fork(watchValidateFields), fork(watchFormValidate), fork(watchFormSubmit), fork(watchCancelInterdiction), fork(watchResumeAfterInterdiction), fork(watchRequestNewCode), fork(watchGetOowView), fork(watchStartInterdiction), fork(watchWorkingStart), fork(watchWorkingEnd), fork(watchCmsRequest), fork(watchWFCmsRequest), fork(watchWFCmsRequestMojoComponents), fork(watchInitializeTrusteer), fork(watchSetTrusteerContext), fork(watchNudataDetectFraud)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, digitalCoreSagas);
});
export default [digitalCoreSagas];